var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-pagination"},[_c('ul',{staticClass:"c-pagination__list"},_vm._l((_vm.items),function(item){return _c('li',{key:item.key,class:{
        'c-pagination__item--active': !item.isDots && item.page === _vm.currentPage,
        'c-pagination__elipsis': item.isDots,
      }},[_vm._v(" "+_vm._s(item.isDots ? '...' : '')+" "),(!item.isDots && item.page === _vm.currentPage)?_c('span',[_vm._v(_vm._s(item.page))]):(!item.isDots)?_c('router-link',{attrs:{"to":_vm.getRouterLinkToParam(item.page)}},[_vm._v(_vm._s(item.page))]):_vm._e()],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }